import { type RouteLocationNormalized } from 'vue-router';
import { useLinesDetailShowStore } from "@/stores/LinesDetailShow";
import { useDetailPageStore } from "@/stores/DetailPage";
import { useDetailShowPageStore } from "@/stores/DetailShowPage";
import { linkItems } from '@/components/Header/types';

const {
	setCurrentItemDetail
} = useDetailPageStore();

const {
    fetchCast,
    fetchRelatedContent,
	clearAllLinesDetailShow
} = useLinesDetailShowStore();

const {
	fetchSeasons
} = useDetailShowPageStore();


export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
	if (import.meta.client) {
		if (from.path === linkItems.player.routerPath) {
			return;
		}
		
		clearAllLinesDetailShow();
		
		setCurrentItemDetail(to.params.id as string);

		void fetchSeasons();		

		void fetchCast();

		void fetchRelatedContent();
	}
});